/**
 * De badge op een eventkaart: kunnen gasten erbij.
 *
 * Dit was de publicatiestatus. Die zei niets — publiceren gebeurde één keer en
 * ging nooit terug, dus stond een feest van vorig jaar nog altijd op "Live" — en
 * hij loog: de badge zei "de QR werkt nog niet" terwijl de gastenkant nooit naar
 * de publicatiestatus keek. Die hele stap is weg.
 *
 * Wat overblijft is de vraag die je je wél stelt als je naar een event kijkt:
 * kan er nog iemand bij. Twee standen, dus één pil.
 */
export function StatusBadge({
  isPrivate,
  onSurface = false,
}: {
  isPrivate: boolean

  /** Op een foto in plaats van op de shell: dan is een eigen ondergrond nodig. */
  onSurface?: boolean
}) {
  if (isPrivate) {
    // Massief en niet in grijstinten. Privé is de stand waarin je gasten niets
    // meer kunnen, en dat hoort op te vallen tussen een rij events waar de rest
    // gewoon openstaat.
    return (
      <span className="bg-ink text-shell flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold">
        <span aria-hidden="true">🔒</span>
        Privé
      </span>
    )
  }

  return (
    <span
      className={
        'text-accent flex items-center gap-1.75 rounded-full px-3 py-1.5 text-xs font-semibold ' +
        (onSurface ? 'bg-shell/92' : '')
      }
    >
      <span aria-hidden="true" className="bg-accent inline-block size-1.75 rounded-full" />
      Open
    </span>
  )
}
